export const POLYGON_OPTIONS = {
  fillColor: 'white',
  fillOpacity: 0.4,
  strokeColor: 'white',
  strokeOpacity: 0,
  strokeWeight: 0,
  clickable: true,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 2,
}

export const POLYGON_OPTIONS_SELECTED = Object.assign({}, POLYGON_OPTIONS)
POLYGON_OPTIONS_SELECTED.fillOpacity = 0.5
POLYGON_OPTIONS_SELECTED.fillColor = '#508090'

export const BACKGROUND_POLYGON_OPTIONS = {
  fillColor: 'gray',
  fillOpacity: 0.3,
  strokeColor: 'gray',
  strokeOpacity: 0,
  strokeWeight: 0,
  clickable: false,
  draggable: false,
  editable: false,
  geodesic: false,
  zIndex: 1,
}
